import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  Avaliacoes,
  AvaliacoesAdd,
  AvaliacoesWaiting,
  AvaliacoesEdit,
  AvaliacoesDocs,
  AvaliacoesOutput,
  AvaliacoesGestorEdit,
  AvaliacoesSettings,
  AvaliacoesSettingsSecaoAdd,
  AvaliacoesSettingsSecaoEdit,
  AvaliacoesSettingsModeloAdd,
  AvaliacoesSettingsModeloEdit,
  AvaliacoesSettingsModeloView,
  AvaliacoesSettingsQuestoesAdd,
  AvaliacoesSettingsQuestoesEdit
} from '../../../pages';
import AvaliacoesProvider from '../../../contexts/AvaliacoesContext';

const AvaliacoesRoutes = () => {
  return (
    <AvaliacoesProvider>
      <Routes>
        <Route path={`add`} element={<AvaliacoesAdd />} />
        <Route path={`add/:id`} element={<AvaliacoesAdd />} />
        <Route path={`waiting/:id`} element={<AvaliacoesWaiting />} />
        <Route path={`docs`} element={<AvaliacoesDocs />} />
        {/* Rotas de configurações de avaliações */}
        <Route path="configuracoes">
          {/* Redirect de /avaliacoes/configuracoes para /avaliacoes/configuracoes/modelo */}
          <Route index element={<Navigate to="modelos" replace />} />
          <Route path=":output" element={<AvaliacoesSettings />} />
          <Route path="secoes/add" element={<AvaliacoesSettingsSecaoAdd />} />
          <Route path="secoes/edit/:id" element={<AvaliacoesSettingsSecaoEdit />} />
          <Route path="questoes/add" element={<AvaliacoesSettingsQuestoesAdd />} />
          <Route path="questoes/edit/:id" element={<AvaliacoesSettingsQuestoesEdit />} />
          <Route path="modelos/add" element={<AvaliacoesSettingsModeloAdd />} />
          <Route path="modelos/edit/:id" element={<AvaliacoesSettingsModeloEdit />} />
          <Route path="modelos/view/:id" element={<AvaliacoesSettingsModeloView />} />
        </Route>
        <Route path={`:id/gestor/:token`} element={<AvaliacoesGestorEdit />} />
        <Route path={`:id/resultado`} element={<AvaliacoesOutput />} />
        <Route path={`:id`} element={<AvaliacoesEdit />} />
        <Route path="" element={<Avaliacoes />} />
      </Routes>
    </AvaliacoesProvider>
  );
};

export default AvaliacoesRoutes;
